import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import styles from './text.css';

const Text = ({ type, size, thin, regular, inline, children, tag }) => {
    const textClass = cx(styles[`s${size}`], {
        [styles.thin]: thin && !regular,
        [styles.regular]: regular && !thin,
        [styles.bold]: !thin && !regular,
        [styles.displayInline]: inline,
        [styles.header]: type === Text.styles.HEADER,
        [styles.body]: type === Text.styles.BODY,
        [styles.donut]: type === Text.styles.DONUT,
    });

    return React.createElement(tag, { className: textClass }, children);
};

/** Public Static Properties */
Text.styles = {
    HEADER: 'header',
    BODY: 'body',
    DONUT: 'donut',
};

Text.availableProperties = {
    [Text.styles.HEADER]: [1, 2, 3],
    [Text.styles.BODY]: [1, 2, 3, 4, 5],
    [Text.styles.DONUT]: [1, 2, 3, 4],
};

Text.propTypes = {
    /** @type {xml} Any text content or spans */
    children: PropTypes.node.isRequired,
    /** @type {boolean} should display text style type */
    type: PropTypes.oneOf(Object.values(Text.styles)),
    /** @type {number} Type size */
    size: PropTypes.number,
    /** @type {boolean} If the base style can be overridden set it to be thin */
    thin: PropTypes.bool,
    /** @type {boolean} If the base style can be overridden set it to be regular */
    regular: PropTypes.bool,
    /** @type {boolean} Set the box display property to inline */
    inline: PropTypes.bool,
    /** @type {string} Sets the tag that content is wrapped within  */
    tag: PropTypes.string,
};

Text.defaultProps = {
    size: 1,
    type: 'body',
    thin: false,
    regular: false,
    inline: false,
    tag: 'div',
};

export default Text;
